import { Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ReturnAfterSignIn from "./ReturnAfterSignIn";

/**
 * AuthRoute - Redirects authenticated users away from auth pages
 * Used for login, register, password reset pages
 *
 * Special case: OAuth linking flow — when ?next= contains /oauth/authorize,
 * the Login component must render even for logged-in users so it can redirect
 * to the backend authorize endpoint with the user's JWT token appended.
 */
const AuthRoute = ({ component: Component, ...rest }) => {
  const user = useSelector((state) => state.user.currentUser);
  const location = useLocation();

  // OAuth flow: let Login handle the redirect back to /oauth/authorize
  const nextUrl = new URLSearchParams(location.search).get("next") || "";
  const isOAuthLinking = nextUrl.includes("/oauth/authorize");

  return (
    <Route {...rest}>
      {user && !isOAuthLinking ? (
        // Signed in: back to where they were (see utils/signInReturn).
        <ReturnAfterSignIn />
      ) : (
        // User is not logged in, OR OAuth linking in progress — show the auth page
        <Component />
      )}
    </Route>
  );
};

export default AuthRoute;
